module.exports = __webpack_public_path__ + "static/media/check_active.bc106bd9.svg";